import * as types from '../../mutationTypes';

export default {
    /* eslint-disable no-param-reassign */
    [types.RESET_CLIENT](state) {
        state.id = null;
        state.name = '';
        state.subdomain = '';
        state.displayName = '';
        state.logoUri = '';
        state.parentId = null;
        state.parent = null;
        state.children = null;
    },

    [types.UPDATE_CLIENT](state, client) {
        state.id = client.id;
        state.name = client.name;
        state.subdomain = client.subdomain;
        state.displayName = client.displayName;
        state.logoUri = client.logoUri;
        state.parentId = client.parentId;
        state.parent = client.parent;
        state.children = client.children;
    },
    /* eslint-enable no-param-reassign */
};



// WEBPACK FOOTER //
// ./src/store/modules/client/mutations.js